(() => {
  const init = () => {
    document.querySelectorAll('[data-asap-home-rides]').forEach((root) => {
      if (root.dataset.asapHomeRidesReady === 'true') return;
      root.dataset.asapHomeRidesReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-asap-rides-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-asap-rides-panel]'));

      const selectTab = (name, focus = false) => {
        tabs.forEach((tab) => {
          const selected = tab.dataset.asapRidesTab === name;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.asapRidesPanel === name;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
          if (selected) panel.querySelector('[data-asap-rides-track]')?.scrollTo({ left: 0, behavior: 'auto' });
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab.dataset.asapRidesTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + direction + tabs.length) % tabs.length;
          selectTab(tabs[next].dataset.asapRidesTab, true);
        });
      });

      root.querySelectorAll('[data-asap-rides-arrow]').forEach((button) => {
        button.addEventListener('click', () => {
          const track = root.querySelector('[data-asap-rides-panel]:not([hidden]) [data-asap-rides-track]');
          if (!track) return;
          const card = track.querySelector('.asap-home-rides__card');
          const distance = card ? card.getBoundingClientRect().width + 28 : track.clientWidth * .8;
          track.scrollBy({
            left: button.dataset.asapRidesArrow === 'next' ? distance : -distance,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
